<template>
  <div id="newPostDesktop">
    <div class="post-body">
      <panel :title="$t('billboard.new')" >
       <div class="top">
         <div class="details-left">
           <div class="group">
             <label>{{ $t("form.title") }}<Tooltip :text="$t('billboard.tooltip.title')"></Tooltip></label>
             <input type="text" v-model="post.title" :class="{invalid: $validate.error('post.title')}">
           </div>
           
           <div class="group">
             <label>{{ $t("form.subtitle") }}<Tooltip :text="$t('billboard.tooltip.subtitle')"></Tooltip></label>
             <input type="text" v-model="post.subTitle" :class="{invalid: $validate.error('post.subTitle')}">
           </div>
           
           <div class="group">
             <FileUploader unique-key="desktop" @upload="setImageData"></FileUploader>
           </div>
           
           <div class="group">
             <label for="publishDate" class="date-picker">
               {{ $t("billboard.publication_date") }}
               <div>
                 <img class="icon" src="@/assets/img/icons/calendar_2.png">
                 <Tooltip :text="$t('billboard.tooltip.startAt')"></Tooltip>
               </div>
             </label>
             <datetime id="publishDate" v-model="post.start"
                       zone="UTC" value-zone="America/New_York"
                       :format="DateTime.DATE_MED"
                       :min-datetime="new Date().toISOString()"
                       :max-datetime="post.end"
             ></datetime>
           </div>
  
           <div class="group">
             <label for="endDate" class="date-picker">
               {{ $t("billboard.end_date") }}
               <div>
                 <img class="icon" src="@/assets/img/icons/calendar_2.png">
                 <Tooltip :text="$t('billboard.tooltip.endAt')"></Tooltip>
               </div>
             </label>
             <datetime id="endDate" v-model="post.end"
                       zone="UTC" value-zone="America/New_York"
                       :format="DateTime.DATE_MED"
                       :min-datetime="post.start ? post.start : new Date().toISOString()"
             ></datetime>
           </div>
         </div>
         
         <div class="details-right">
           <div class="group">
             <label for="">{{ $t("form.content") }} <Tooltip :text="$t('billboard.tooltip.content')"></Tooltip></label>
             <textarea name="" cols="30" rows="10" v-model="post.body" :class="{invalid: $validate.error('post.body')}"></textarea>
           </div>
         </div>
       </div>
      </panel>
    </div>
  
    <div class="buttons">
      <div @click="publish" class="btn btn-primary">{{ $t("billboard.publish") }}</div>
      <div @click="back" class="btn btn-secondary">{{ $t("billboard.back") }}</div>
    </div>
    
  </div>
</template>

<script>
  import FileUploader from "../../components/FileUploader";
  import Panel from "../Panel";
  import Tooltip from "../../components/Tooltip";

  
  export default {
    name: "NewPostDesktop",
    
    props: {
      post: Object,
      DateTime: Function,
      
      back: Function,
      publish: Function,
      setImageData: Function
    },
    
    components: {
      FileUploader,
      Panel,
      Tooltip
    },
    
    computed: {
      years() {
        const year = new Date().getFullYear()
        return Array.from({length: 10}, (value, index) => year + index)
      }
    },

    validate: {
      "post.title": {required: true},
      "post.subTitle": {required: false},
      "post.body": {required: true},
      "post.start": {required: true, date: true},
      "post.end": {required: true, date: true}
    },
  }
</script>

<style lang="scss" scoped>
  #newPostDesktop {
    padding: 30px 60px 30px 60px ;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
  }
  
  input, textarea {
    color: #001722;
  }

  .post-body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  
  }

  .top {
    display: flex;
    flex-shrink: 0;
    & > div:not(:last-of-type) {
      margin-right: 40px;
    }
  }
  .details-left {
    flex-shrink: 0;
    flex-grow: 1;
    flex-basis: 0;
  }

  .details-right {
    flex-grow: 1;
    flex-basis: 0;
    
    .group {
      flex-grow: 1;
    }
  }

  .group {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    flex-basis: 0;
    margin-bottom: 20px;
    
  }

  label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    margin-bottom: 6px;
    color: #bfc5c8;
    &.date-picker > div{
      display: flex;
      align-items: center;
      img {
        position: relative;
        top: 38px;
        left: 10px;
        pointer-events: none;
      }
    }
    

  }
  
  .vdatetime-input {
    cursor: pointer;
  }
  
  textarea {
    flex-grow: 1;
  }
  
  .buttons {
    display: flex;
    margin-top: 40px;
    margin-bottom: 20px;
    margin-right: auto;
    align-self: flex-start;
    
    .btn {
      flex-grow: 1;
      min-width: 180px;
      &:not(:last-of-type) {
        margin-right: 20px;
      }
    }
  }
</style>